import { useState } from "react";
import { Tab } from "semantic-ui-react";
import CustomerForm from "../components/CustomerForm";
import Schedule from "../components/Schedule";

const Customer = () => {
  const[activeIndex,setActiveIndex]=useState(0);
  const panes = [
    {
      menuItem: "Customer Info",
      render: () => (
        <Tab.Pane attached={false}>
          <CustomerForm setActiveIndex={setActiveIndex}/>
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Access",
      render: () => (
        <Tab.Pane attached={false}>
          <Schedule />
        </Tab.Pane>
      ),
    },
   
  ];

  return <Tab menu={{ secondary: true, pointing: true }} panes={panes}  activeIndex={activeIndex}/>
};

export default Customer;

